import {
  TIME_LINE_DEFAULT_MODE,
  TIME_LINE_DEFAULT_TIME_INTERVAL_INCREMENT,
  TIME_LINE_DEFAULT_TIME_INTERVAL_SHOW_FILTER,
  TIME_LINE_OBJECT_X_CELL_MIN_HEIGHT,
  TIME_LINE_OBJECT_X_CELL_MIN_WIDTH,
} from '@constants'
import { MainObjectTypeEnum, TimeLineGridConfig, TotalRow } from '@types'

export const getDefaultValues = (): TimeLineGridConfig => {
  return {
    code: '',
    title: '',
    jsonConfig: '',
    timeInterval: {
      increment: TIME_LINE_DEFAULT_TIME_INTERVAL_INCREMENT,
      showFilter: TIME_LINE_DEFAULT_TIME_INTERVAL_SHOW_FILTER,
    },
    objectY: {
      keyField: null,
      preFilter: null,
      getDataCommand: {
        internalId: '',
        type: null,
        name: null,
        parameters: [],
        body: [],
      },
      actions: [],
      columns: [],
    },
    objectX: {
      objectCode: undefined,
      getDataCommand: {
        internalId: '',
        type: null,
        name: null,
        parameters: [],
        body: [],
      },
      cell: {
        bindType: null,
        value: '',
        minWidth: TIME_LINE_OBJECT_X_CELL_MIN_WIDTH,
        minHeight: TIME_LINE_OBJECT_X_CELL_MIN_HEIGHT,
      },
      startDateField: null,
      endDateField: null,
      linkToObjectY: {
        keyField: null,
        pathArray: [],
      },
      keyField: {
        keyField: null,
        pathArray: [],
      },
      linkToColumnsObject: {
        keyField: null,
        pathArray: [],
      },
      fieldFromColumnsObjectToLink: {
        keyField: null,
        pathArray: [],
      },
      fieldFromObjectYToLink: {
        keyField: null,
        pathArray: [],
      },
      columnsObject: {
        object: undefined,
        command: {
          internalId: '',
          type: null,
          name: null,
          parameters: [],
          body: [],
        },
        headerBindType: null,
        headerField: { keyField: null, pathArray: [] },
        headerScript: '',
      },
      actions: [],
      columns: [],
      totalsRows: [],
    },
    mainObject: {
      objectType: MainObjectTypeEnum.Y,
      groupTitleType: null,
    },
    showUpdateTimeLineDataButton: false,
    actions: [],
    variables: [],
    showDayOfWeek: false,
    searchAssistant: null,
    mode: { id: TIME_LINE_DEFAULT_MODE, label: TIME_LINE_DEFAULT_MODE },
    filterColumnsObjectByObjectX: false,
    filterObjectYByObjectX: false,
  }
}

export const getObjectXTotalRowDefaultValue = (): TotalRow => {
  return {
    title: '',
    commands: [],
    bindType: null,
    script: '',
  }
}
